import React, { useEffect, useRef } from 'react'
import { Dialog, useMediaQuery } from '@material-ui/core'
import { useTheme, makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { useBreakpoints } from 'commons/useBreakpoints'
import * as R from 'ramda'

export const useDialogStyle = makeStyles((theme) => ({
  root: {
    borderColor: theme.palette.borderColor.default,
  },
  dialogPaper: {
    [useBreakpoints(theme).lessThan.sm]: {
      width: '90vw',
      marginLeft: '1.2rem !important',
      marginRight: '1.2rem !important',
    },
  },
  title: {
    color: theme.palette.primary.main,
  },
  //Woraround bug on Material-UI Label
  labelBackground: {
    '& .MuiInputLabel-outlined': {
      background: 'white',
      paddingRight: '4px',
    },
  },
  dialog: {
    '& .MuiDialogTitle-root': {
      paddingTop: '32px',
      paddingBottom: '16px',
      paddingLeft: '0',
      paddingRight: '0',
      [theme.breakpoints.down('xs')]: {
        paddingTop: '16px',
        paddingBottom: '16px',
      },
    },
    '& .MuiDialogContent-root': {
      paddingTop: '0',
      paddingBottom: '0',
      paddingLeft: '0',
      paddingRight: '0',
      overflowX: 'hidden',
      overflowY: 'overlay',
    },
    '& .MuiDialogActions-root': {
      paddingTop: '24px',
      paddingBottom: '16px',
      paddingLeft: '0',
      paddingRight: '0',
      [theme.breakpoints.down('xs')]: {
        paddingTop: '16px',
        paddingBottom: '16px',
      },
    },
  },
  dialogContent: {
    paddingLeft: '32px !important',
    paddingRight: '32px !important',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '16px !important',
      paddingRight: '16px !important',
    },
  },
  classClose: {
    textAlign: 'center',
    fontSize: '20px',
    cursor: 'pointer',
  },
  iconSize: {
    fontSize: '22px',
    color: '#000000',
    fontWeight: 'bold',
  },
  switchMaterial: {
    marginLeft: '30px',
  },
  voucherStyle: {
    '& .MuiListItem-gutters': {
      padding: '30px',
    },
    '& .MuiSelect-select': {
      [theme.breakpoints.down('xs')]: {
        whiteSpace: 'unset',
        '& div': {
          display: 'unset !important',
        },
        '& label': {
          paddingRight: '0 !important',
          paddingLeft: '0 !important',
        },
        '& p': {
          paddingRight: '50px !important',
        },
      },
    },
  },
}))

export default ({
  isFullScreen = true,
  PaperProps,
  fullWidth,
  removeAllSpace,
  topicDialog,
  topicDialogStyles,
  dataTestId = 'dialog',
  ...props
}) => {
  const theme = useTheme()
  const classes = useDialogStyle()
  const isDownXs = useMediaQuery(theme.breakpoints.down('xs'))
  const paperProps = R.dissoc('className', PaperProps)
  const paperClassName = R.prop('className', PaperProps)

  const ref = useRef()

  // Remove tabIndex to enable typing on input text
  useEffect(() => {
    if (!ref.current) return
    const dialog = ref.current
    const container = dialog.querySelector(
      '.MuiDialog-container.MuiDialog-scrollPaper',
    )
    if (container) {
      container.removeAttribute('tabIndex')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current, props.open])

  return (
    <Dialog
      ref={ref}
      PaperProps={{
        className: clsx(
          paperClassName,
          !isFullScreen ? classes.dialogPaper : '',
          topicDialogStyles
            ? topicDialogStyles
            : R.equals(removeAllSpace, true)
              ? classes.dialog
              : '',
        ),
        ...paperProps,
      }}
      fullScreen={isDownXs && isFullScreen}
      fullWidth={fullWidth || !isDownXs}
      data-testid={dataTestId}
      {...props}
    >
      {props.children}
    </Dialog>
  )
}
